<template>
  <div>
    <el-popover placement="left" :width="boxWidth" :trigger="popoverTrigger"  popper-class="pd0">
      <el-table :data="selectArray" border size="mini" :max-height="tableHeight" :header-cell-style="tableHeaderColor">
        <el-table-column
            v-if="sortDisabled"
            label="序号"
            type="index"
            align="center"
            width="50">
          </el-table-column>
          <el-table-column
            v-if="imageDisabled"
            label="图片"
            type="picJsonList"
            min-width="100px"
            align="center"
            >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.fileUrl"
                style="width: 100px; height: 100px"
                :src="scope.row.fileUrl"
                fit="fill">
              </el-image>
              <div v-else-if="scope.row.picJsonList">
                <!-- <el-image
                  v-for="(itemImg,indexImg) in scope.row.picJsonList"
                  :key="indexImg"
                  style="width: 100px; height: 100px"
                  :src="itemImg.fileUrl"
                  fit="fill">
                </el-image> -->
                <popoverTipList
                  ref="myPopoverTipList"
                  v-if="scope.row.picJsonList.length > 0 "
                  popoverTrigger="hover"
                  labelValue = 'id'
                  tableType = "length"
                  tableHeight = '500px'
                  boxWidth="200"
                  :imageDisabled="true"
                  :columns="[
                  ]"
                  :selectArray="scope.row.picJsonList"
                ></popoverTipList>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
        <template v-for="(column, index) in columns">
          <el-table-column
            :key="index"
            :prop="column.prop"
            header-align="center"
            align="center"
            min-width="100px"
            :label="column.label"
          ></el-table-column>
        </template>
      </el-table>
      <el-button type="text" slot="reference">
        <span>{{ tableType == 'text'? name : selectArray.length }}</span>
      </el-button>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'popoverTipList',
  data () {
    return {
      name: '',
      selectData: []
    }
  },
  props: {
    limit: Number,
    popoverTrigger: {
      type: String,
      default: () => {
        return 'click'
      }
    },
    value: {
      type: String,
      default: () => {
        return null
      }
    },
    tableType: {
      type: String,
      default: () => {
        return 'text'
      }
    },
    boxWidth: {
      type: String,
      default: () => {
        return '700'
      }
    },
    tableHeight: {
      type: String,
      default: () => {
        return '300px'
      }
    },
    sortDisabled: {
      type: Boolean,
      default: false
    },
    imageDisabled: {
      type: Boolean,
      default: false
    },
    labelValue: {
      type: String,
      default: () => {
        return 'id'
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectArray: {
      type: Array,
      default: () => {
        return []
      }
    },
    queryEntityUrl: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  components: {},
  watch: {
    value: {
      handler (newVal) {
        this.selectData = []
        if (newVal) {
          this.selectData = this.selectArray
          this.name = this.selectArray.map(user => { return user.nameCn }).join(',')
          // newVal.split(',').forEach(value => {
          //   if (value) {
          //     this.$http
          //       .get(`${this.queryEntityUrl}?${this.labelValue}=${value}`)
          //       .then(({ data }) => {
          //         if (data[this.labelValue] !== '') {
          //           this.selectData.push(data)
          //         }
          //       })
          //   }
          // })
        }
      },
      immediate: true,
      deep: false
    }
  },
  methods: {
    // 设置表头颜色
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      return {background: '#f7f7f7'}
    }
  }
}
</script>
<style lang="scss" scoped>
.pd0{
  padding: 0 !important;
}
</style>
    
    
    